// eslint-disable-next-line import/prefer-default-export
export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
